<template>
  <div>
    <template v-if="loading">
      <div class="custom-skeleton p-4">
        <ul class="m-0 p-0">
          <li v-for="(_, key) in showAll ? 3 : 1" :key="key" class="mb-10">
            <div class="flex">
              <Skeleton shape="circle" size="4rem" class="mr-2"></Skeleton>
              <div style="flex: 1">
                <Skeleton width="100%" class="mb-2"></Skeleton>
                <Skeleton width="75%"></Skeleton>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </template>
    <template v-else>
      <template v-if="invitations.length">
        <template v-if="invitations.length > 1 && !showAll">
          <Message class="invitation-item" severity="info" :closable="false">
            <div class="flex items-center justify-between">
              <div>
                Vous avez des invitations, rendez-vous dans "Gérer mes invitations"
              </div>
              <div>
                <router-link :to="{ name: 'Invitations' }" title="Mes invitations">
                  <Button label="Gérer mes invitations" icon="mdi-email-multiple" click="btn-blue" />
                </router-link>
              </div>
            </div>
          </Message>
        </template>
        <template v-else>
          <InvitationItem
            v-for="invitation in invitations"
            :key="invitation.id"
            :invitation="invitation"
            @accept="treatInvitation(invitation, true)"
            @decline="treatInvitation(invitation, false)"
          />
        </template>
      </template>
      <template v-else-if="showAll">
        <div class="w-100 text-center mt-20">
          <v-mdi name="mdi-email-alert-outline" class="w-24 h-24"></v-mdi>
          <p>Vous n'avez pas d'invitation.</p>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import Skeleton from "primevue/skeleton";
import InvitationItem from "./InvitationItem.vue";

export default {
  components: {
    Skeleton,
    InvitationItem,
  },
  props: {
    showAll: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    invitations: [],
    loading: false,
  }),
  async mounted() {
    this.loading = true;
    this.invitations = (await axios.get("project_invitations")).data;
    this.loading = false;
  },
  methods: {
    async treatInvitation(invitation, accept) {
      const { id, project_id } = invitation;

      let mustReloadProjects = false;
      if(this.invitations.length == 1 && !this.showAll && accept){
        mustReloadProjects = true;
      }

      try{
        await axios.post(`project_invitations/${id}/projects/${project_id}/${accept ? "accept" : "decline"}`);

        const indexToRemove = this.invitations.indexOf(invitation);
        this.invitations.splice(indexToRemove, 1);

        this.$toast.add({
          severity: "success",
          summary: `Invitation ${accept ? "acceptée" : "refusée"}`,
          detail: `L'invitation a été traitée avec succès`,
          life: 3000,
        });

        if(mustReloadProjects){
          this.$emit('reloadProject', true);
        }
      } catch(error) {
          this.$toast.add({
            severity: "error",
            summary: `Erreur survenue`,
            detail: `Impossible de traiter l'invitation`,
            life: 3000,
          });
      };

    },
  },
};
</script>
